import isCamelCase from './isCamelCase';

/**
 * Converts a hyphen-case string to camelCase
 * @function hyphenToCamelCase
 * @param {string} str - The string to be formatted
 * @param {boolean} [preserveExistingCapitalization=false] - If true, the existing capitalization will be preserved
 * @return {string}
 * @example hyphenToCamelCase('test-string') => 'testString'
 * @example hyphenToCamelCase('tEst-sTrInG') => 'testString' -- Handles mixed case inputs
 * @example hyphenToCamelCase('tEst-sTrInG', true) => 'tEstSTrInG' -- Handles mixed case inputs and optionally preserves existing capitalization
 * @example hyphenToCamelCase('TEST') => 'test' -- Handles all uppercase inputs
 * @example hyphenToCamelCase('testString') => 'testString' -- Handles already camelCased inputs
 */
const hyphenToCamelCase = (str, preserveExistingCapitalization) => {
  if (isCamelCase(str)) return str;
  return (str ?? '')
    .split('-')
    .map((word, index) => {
      const first = index === 0 ? word.charAt(0).toLowerCase() : word.charAt(0).toUpperCase();
      const rest = preserveExistingCapitalization ? word.slice(1) : word.slice(1).toLowerCase();
      return `${first}${rest}`;
    })
    .join('');
};

export default hyphenToCamelCase;
